/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Soyun Lee (sylee2@rsupport.com)
 *
 * @description
 *
 * @created at Wed Oct 30 2024
 **/

import { useConfirm } from "@/frameworks/core/hooks";
import { Button } from "@/frameworks/designStuff/components";
import { _T } from "@rfice/language";
import { usePersistActions } from "@/frameworks/core/persistence";

interface UploadToMyDeskProps {
	file: Required<FileBox.Folders.GetFolderFileListResponse>["content"][number];
}

export default function UploadToMyDeskBackground(props: UploadToMyDeskProps) {
	const { mydeskWidgets } = usePersistActions();
	const { confirm } = useConfirm();

	const saveBackgroundConfirm = () => {
		confirm(
			{ title: _T("해당 이미지를 배경화면으로 지정하시겠습니까?") },
			{
				onConfirm() {
					props.file.filePath && mydeskWidgets.set_background_CustomImageURL(props.file.filePath);
				}
			}
		);
	};

	return (
		<Button.Icon
			name="Svg3DshareTv24"
			size="XXlarge"
			filled="transparent"
			fill="neutral_80_100"
			onClick={saveBackgroundConfirm}
		/>
	);
}
